import { camelizeKeys, tokenUtils } from "utils";

export default async function fetchJSON(url, options = {}) {
    const token = tokenUtils.getToken();

    return new Promise((resolve, reject) => {
        const newOptions = {
            method: options.method,
            mode: "cors",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
                ...options.headers,
            },
        };

        if (options.body) {
            newOptions.body = JSON.stringify(options.body);
        }

        fetch(url, newOptions)
            .then(async (response) => {
                const json = await response.json().catch(() => null);

                if (!response.ok) {
                    const errorMessage = json?.detail || json?.message || "An error occurred";
                    reject({
                        statusCode: response.status,
                        statusText: response.statusText,
                        message: errorMessage,
                        data: json || null,
                    });
                } else {
                    resolve({
                        statusCode: response.status,
                        statusText: response.statusText,
                        ...camelizeKeys(json || {}),
                    });
                }
            })
            .catch((error) => {
                reject({
                    statusCode: 0,
                    message: error.message || "Network error",
                    data: null,
                });
            });
    });
}
